module.exports = __webpack_public_path__ + "static/car5-0e1e75c14d6a5e91eff23ecf2d8a13eb.jpg";